/**
 * Determines if the code is executing inside a traceable (lambda) environment
 *
 * This is required to avoid issues when running locally, or when instrumented code
 * is executed in the browser (which shouldn't happen if next.js is correctly configured)
 */ export var isTraceableEnvironment = function() {
    var ref;
    return (ref = process.env["AWS_EXECUTION_ENV"]) === null || ref === void 0 ? void 0 : ref.startsWith("AWS_Lambda_");
};
